import { IPaginationDTO, ITeamDTO, IYearDTO, IYearInfoDTO } from '@/dtos';
import { get, post, remove, generatePagination } from '@/services/apiWrapper';

export const getAllYearsAPI = async (
  pagination: IPaginationDTO,
): Promise<{ data: IYearDTO[]; count: number }> => {
  const pageOptions = await generatePagination(pagination);
  const years = await get<{ data: IYearDTO[]; count: number }>(`/admin/years${pageOptions}`);
  return years;
};

export const getYearById = async (id: string): Promise<IYearDTO> => {
  const year = await get<IYearDTO>(`/admin/years/${id}`);
  return year;
};

export const getYearInfoAPI = async (id: string): Promise<IYearInfoDTO> => {
  const year = await get<IYearInfoDTO>(`/admin/years/${id}/info`);
  return year;
};

export const saveYearAPI = async (year: IYearDTO): Promise<IYearDTO> => {
  const ret = await post<IYearDTO>(`/admin/years/${year.id}/save`, year);
  return ret;
};

export const createYearAPI = async (body: IYearDTO): Promise<IYearDTO> => {
  const year = await post<IYearDTO>(`/admin/years/createYear`, body);
  return year;
};

export const deleteYearAPI = async (id: string): Promise<boolean> => {
  const year = await remove<boolean>(`/admin/years/${id}`);
  return year;
};

export const getTeamsForYearAPI = async (
  yearId: string,
  pagination: IPaginationDTO,
): Promise<{ data: ITeamDTO[]; count: number }> => {
  const pageOptions = await generatePagination(pagination);
  const teams = await get<{ data: ITeamDTO[]; count: number }>(
    `/admin/years/${yearId}/teams${pageOptions}`,
  );
  return teams;
};

export const getIncompleteTeamsForYearAPI = async (
  yearId: string,
  pagination: IPaginationDTO,
): Promise<{ data: ITeamDTO[]; count: number }> => {
  const pageOptions = await generatePagination(pagination);
  const teams = await get<{ data: ITeamDTO[]; count: number }>(
    `/admin/years/${yearId}/incomplete${pageOptions}`,
  );
  return teams;
};

export const getTeamsForYearWithCheckinAPI = async (
  branchId: string,
  yearId: string,
  pagination: IPaginationDTO,
): Promise<{ data: ITeamDTO[]; count: number }> => {
  const pageOptions = await generatePagination(pagination);
  const teams = await get<{ data: ITeamDTO[]; count: number }>(
    `/admin/years/${yearId}/branch/${branchId}/teams/withReg${pageOptions}`,
  );
  return teams;
};

export const getTeamsForYearWithSubmissionsAPI = async (body: any) => {
  const pageOptions = await generatePagination(body.pageOptions);
  const teams = await get(`/admin/years/${body.yearId}/teams/withSubmissions${pageOptions}`);
  return teams;
};

export const getTeamsTermsForYearAPI = async (yearId: string) => {
  const terms = await get(`/admin/years/${yearId}/teams/terms`);
  return terms;
};

export const addTeamsToYearAPI = async (id: string, data: any) => {
  const teams = await post(`/admin/years/${id}/addTeams`, data);
  return teams;
};

export const getTeamYearAPI = async (yearId: string, teamId: string): Promise<ITeamDTO> => {
  const teams = await get<ITeamDTO>(`/admin/years/${yearId}/team/${teamId}`);
  return teams;
};
export const removeTeamFromYearAPI = async (id: string, teamId: string) => {
  const teams = await remove(`/admin/years/${id}/teams/${teamId}`);
  return teams;
};

export const addTeamMembersToYearAPI = async (teamId: string, yearId: string, data: any) => {
  const teams = await post(`/admin/years/${yearId}/team/${teamId}/members`, data);
  return teams;
};
